import React from "react";
import Services from "../../api/Services";
import { Link } from "react-router-dom";
// import ins1 from "../../images/instragram/img-1.jpg";
// import ins2 from "../../images/instragram/img-2.jpg";
// import ins3 from "../../images/instragram/img-3.jpg";
// import ins4 from "../../images/instragram/img-4.jpg";
// import ins5 from "../../images/instragram/img-5.jpg";
// import ins6 from "../../images/instragram/img-6.jpg";

const ServiceSidebar = (props) => {
  // const SubmitHandler = (e) => {
  //   e.preventDefault();
  // };

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div className="col-lg-4 col-md-8">
      <div className="single-sidebar">
        <div className="service-widget widget">
          <h2>All Services</h2>
          <ul>
            {Services.slice(0, 6).map((service, Sitem) => (
              <li key={Sitem}>
                <Link
                  onClick={ClickHandler}
                  to={`/services/${service.slug}`}
                >
                  {service.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="web-app-widget widget" style={{textAlign:'justify'}}>
          <h3>Empowering Your Digital Journey</h3>
          <p>
            At THINKBIG INFOTECH, we specialize in delivering smart, scalable,
            and customized IT solutions that empower businesses to grow, adapt,
            and thrive in today's fast-paced digital world. Whether you're a
            startup aiming for rapid market entry or an established enterprise
            seeking digital transformation, we partner with you at every step of
            your journey.
          </p>

          <ul className="common-service-highlights ">
            <li>1. Tailored strategies for your business goals</li>
            <li>2. Expertise team </li>
            <li>3. Reliable support from start to success</li>
            <li>4. Agile Methodology</li>
            <li>5. Cost-Effective Solutions</li>
            <li>6. Scalable solutions</li>
            <li>7. Future Ready Technologies</li>

            <li>8. Client Centric Approach</li>

            <li>9. End-to-End Digital Transformation</li>
          </ul>
        </div>

        {/*<br></br><br></br>
<div className="web-app-widget widget">
  <h3>Our Mission & Vision</h3>
  <p><strong>Mission:</strong> To empower businesses through innovative, reliable and scalable digital solutions that drive growth, efficiency and long-term success.</p>
  <p><strong>Vision:</strong> To be a trusted global technology partner, recognized for delivering excellence in every line of code, design and strategy ,turning complex challenges into impactful outcomes.</p>
  <ul className="web-app-benefits">
    <li>1. Client-Centric Approach</li>
    <li>2. Innovation at Every Step</li>
    <li>3. Quality-Driven Development</li>
    <li>4. Long-Term Business Value</li>
    <li>5. Transparent Collaboration</li>
    <li>6. Scalable, Future-Ready Solutions</li>
  </ul>
</div>*/}
      </div>
    </div>
  );
};

export default ServiceSidebar;
